import { Link } from '../../../widgets/buttons';
import PrintfulLogo from 'src/shared/svg/podPrintfulLogo';
import styled from 'styled-components';

export interface ApiKey {
    clientId: number;
    id: string;
    statusId: number;
    providerId: number;
    descriptionKey: string | null;
    autoConfirmOrders: boolean;
    secretKey: string | null;
    printfulPrefix: string | null;
    printfulSuffix: string | null;
    invitionPhoneNumber: string | null;
}

export interface ApiKeyInput {
    id?: string;
    providerId: number;
    secretKey: string;
    descriptionKey: string;
    autoConfirmOrders?: boolean;
    partnerCode?: string;
    printfulPrefix: string | null;
    printfulSuffix: string | null;
    invitionPhoneNumber: string | null;
}

export interface ProviderProps {
    apiKey: ApiKey | null;
    onAdd: (apiKey: ApiKeyInput) => void;
    onDelete: (id: string, providerId: number) => void;
    onIntegrate?: (provider: number) => void;
    ecommerceId?: number;
    masterIntegrationUrl?: string | null;
}

export enum ProductProviders {
    Printful = 1,
    CustomCat = 2,
    Invition = 3,
    PrintfulDirect = 4,
    HP = 5
}

export enum ECommerces {
    WooCommerce = 2,
    Shopify = 3,
    BigCommerce = 9
}

export const LogoContainer = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 32px;
    div {
        position: absolute;
        font-weight: 600;
    }
`;

export const LogoPrintful = styled(PrintfulLogo)`
    height: 32px;
    width: 120px;
`;

export const Buttons = styled.div`
    display: flex;
    gap: 30px;
    justify-content: flex-end;
`;

export const InstructionsCallout = styled.div`
    background: #f3f5f6;
    border: 1px solid #dbe2e6;
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 24px;
`;

export const Description = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 8px;
    text-align: justify;
    p {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
        ${Link} {
            font-size: 14px;
            line-height: 20px;
        }
    }
    ${Link} {
        font-size: 14px;
        line-height: 20px;
    }
`;
